// 时间戳转换
const changeFormat = (timestamp, flg, start, end) => {
  // timestamp 时间戳
  // flg 分隔符
  // start 转换开始标识 'year', 'month', 'day', 'hour', 'minutes', 'second'
  // end 转换结束标识 'year', 'month', 'day', 'hour', 'minutes', 'second'
  if(!timestamp)return
  let _timestamp = null
  if(/^\d+$/.test(timestamp)){
    _timestamp = timestamp
  }else if(/-/.test(timestamp)){
    _timestamp = timestamp.replace(new RegExp(/-/gm) ,'/')
  }else{
    _timestamp = timestamp// .replace(new RegExp(/-/gm) ,'/')
  }

  // 日期月份/天的显示，如果是1位数，则在前面加上'0'
  let getFormatDate = (arg) => {
    arg = String(arg);
    if (arg == 'undefined' || arg == '') {
      return '';
    }
    var re = arg + '';
    if (re.length < 2) {
      re = '0' + re;
    }
    return re;
  }

  let getIndexOf = (key, arr, callback) => {
    for (let i = 0; i < arr.length; i++) {
      if (key == arr[i]) {
        callback(i);
      }
    }
  }

  var time = new Date(_timestamp);
  var y = getFormatDate(time.getFullYear()) + (!flg || flg == undefined ? '年' : flg);
  var m = getFormatDate(time.getMonth() + 1) + (!flg || flg == undefined ? '月' : '');
  var d = (!flg || flg == undefined ? '' : flg) + getFormatDate(time.getDate()) + (!flg || flg == undefined ? '日 ' : '');
  var h = ' ' + getFormatDate(time.getHours()) + ':';
  var mm = getFormatDate(time.getMinutes());
  var s = ':' + getFormatDate(time.getSeconds());

  var timeStr = '';
  var timeKeyArr = ['year', 'month', 'day', 'hour', 'minutes', 'second'];
  var timeArr = [y, m, d, h, mm, s];
  getIndexOf(start, timeKeyArr, (_start) => {
    getIndexOf(end, timeKeyArr, (_end) => {
      let _newTimeArr = timeArr.slice(_start, _end + 1);
      for (let item of _newTimeArr) {
        timeStr += item;
      }
    })
  })

  return timeStr;
}

export default changeFormat
